import axios from 'axios'
import * as types from './types'

const BASE_RESOURCE = '/api/financial_batches'

// Sentinela de "entidade PN" para GET_FINANCIAL_BATCHES_BY_ENTITY. Não é um
// auditable_type: é o que desvia a chamada para a rota by_consultant.
const CONSULTANT_ENTITY_TYPE = 'consultant'

export default {
  // A fila que alimenta a faixa no topo da tela de ajustes: operações APLICADAS
  // que o Financeiro ainda não leu. O backend já filtra por mode=apply e limita a
  // 20 — não há paginação aqui de propósito, é uma faixa e não uma listagem.
  [types.GET_UNREAD_FINANCIAL_BATCHES]: ({ commit }) => axios.get(`${BASE_RESOURCE}/unread`)
    .then(resp => {
      commit(types.MUTATE_UNREAD_FINANCIAL_BATCHES, resp.data)
      return Promise.resolve(resp)
    })
    .catch(err => Promise.reject(err)),
  // O backend responde 405 quando recusa a leitura (lote já revisado, lote em
  // dry-run ou o próprio autor da execução tentando dar baixa nele mesmo). O
  // interceptor de src/helpers/api.js desloga o usuário em 401/403/419, por isso a
  // recusa vem como 405. O erro precisa chegar inteiro no componente para que a
  // tela exiba err.response.data.message em vez de um erro genérico.
  /**
   * O histórico recente: os últimos lotes aplicados, lidos ou não.
   *
   * ⚠️ Rota separada de `unread`, e não um parâmetro nela. As duas respostas alimentam slots
   * diferentes do store porque a manchete da faixa conta os NÃO LIDOS e precisa continuar
   * correta enquanto o painel exibe "Todos".
   */
  [types.GET_RECENT_FINANCIAL_BATCHES]: ({ commit }) => axios.get(`${BASE_RESOURCE}/recent`)
    .then(resp => {
      commit(types.MUTATE_RECENT_FINANCIAL_BATCHES, resp.data)
      return Promise.resolve(resp)
    })
    .catch(err => Promise.reject(err)),
  [types.ACKNOWLEDGE_FINANCIAL_BATCH]: (_, payload = {}) => {
    const { reference, ...body } = payload
    return axios.post(`${BASE_RESOURCE}/${reference}/acknowledge`, body)
      .then(resp => Promise.resolve(resp))
      .catch(err => Promise.reject(err))
  },
  [types.OPEN_FINANCIAL_BATCH_ACKNOWLEDGE_MODAL]: ({ commit }, payload) => {
    commit(types.MUTATE_FINANCIAL_BATCH_ACKNOWLEDGE_MODAL, {
      ...payload,
      visible: true,
    })
  },
  // Lotes que tocaram uma entidade específica.
  //
  // `by_entity/{type}/{id}` espera o NOME CURTO da classe em PascalCase — Commission,
  // Contract, FinancialAdjustment, Payment... — porque o backend reconstrói dali a FQCN
  // guardada em auditable_type (FinancialBatchQueryService::entityTypeCandidates). Ele
  // NÃO pagina: devolve { operation, items, operations } de uma vez.
  //
  // O PN não é uma dessas entidades: nenhum model de consultor é auditado em lote, o PN
  // aparece só na coluna consultant_id dos itens. Quem responde por ele é
  // `by_consultant/{id}`, que recebe o ID numérico, pagina e ainda soma
  // consultant_net_diff. Por isso a sentinela abaixo, comparada sem diferenciar caixa:
  // o despachante manda o tipo em PascalCase e `type === 'consultant'` nunca casava.
  [types.GET_FINANCIAL_BATCHES_BY_ENTITY]: (_, payload = {}) => {
    const {
      type, id, page, limit,
    } = payload
    const byConsultant = String(type || '').toLowerCase() === CONSULTANT_ENTITY_TYPE
    const resource = byConsultant
      ? `${BASE_RESOURCE}/by_consultant/${id}`
      : `${BASE_RESOURCE}/by_entity/${type}/${id}`
    return axios.get(resource, {
      // Mandar page/limit para by_entity prometeria uma paginação que a rota não tem.
      params: byConsultant
        ? { page: page || 1, limit: limit || undefined }
        : undefined,
    })
      .then(resp => Promise.resolve(resp))
      .catch(err => Promise.reject(err))
  },
}
